export default __webpack_public_path__ + "static/media/grafema_SET_06.b218886a.jpg";